import { Button } from "./button.tsx";
import { formatDate } from "./uiComponents.tsx";

export type SmsMessage = {
  id: string;
  fromNumber: string;
  body: string;
  receivedAt: number;
};

export type PhoneNumberView = {
  id: string;
  number: string;
  provider?: string | null;
  price?: number | null;
  smsMessages?: SmsMessage[];
};

const phoneNumberRowStyle = {
  padding: "16px",
  border: "1px solid var(--border)",
  borderRadius: "8px",
  backgroundColor: "var(--surface)",
  display: "flex",
  flexDirection: "column" as const,
  gap: 12,
};

const smsListStyle = {
  listStyle: "none" as const,
  padding: 0,
  margin: 0,
  display: "flex",
  flexDirection: "column" as const,
  gap: 6,
};

const smsRowStyle = {
  padding: "8px 10px",
  border: "1px solid var(--border)",
  borderRadius: 6,
  fontSize: 13,
};

const phoneNumbersContainerStyle = {
  padding: 20,
  display: "flex",
  flexDirection: "column" as const,
  gap: 12,
};

const phoneNumbersHeaderStyle = {
  display: "flex",
  alignItems: "center",
  gap: 10,
};

const phoneNumbersListStyle = {
  listStyle: "none" as const,
  padding: 0,
  margin: 0,
  display: "flex",
  flexDirection: "column" as const,
  gap: 8,
};

const phoneNumberRowHeaderStyle = {
  display: "flex",
  alignItems: "center",
  gap: 12,
  flexWrap: "wrap" as const,
};

const sortByReceivedAtDesc = (messages: SmsMessage[]) =>
  [...messages].sort((a, b) => b.receivedAt - a.receivedAt);

export const SmsInbox = ({ messages }: { messages: SmsMessage[] }) => {
  if (messages.length === 0) {
    return <div style={{ fontSize: 12, opacity: 0.7 }}>No SMS yet.</div>;
  }
  return (
    <ul style={smsListStyle}>
      {messages.map((m) => (
        <li key={m.id} style={smsRowStyle}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              flexWrap: "wrap",
            }}
          >
            <strong>+{m.fromNumber}</strong>
            <span style={{ opacity: 0.6 }}>
              {formatDate(m.receivedAt)}
            </span>
          </div>
          <div style={{ marginTop: 4 }}>{m.body}</div>
        </li>
      ))}
    </ul>
  );
};

export const PhoneNumbersView = ({
  phoneNumbers,
  onAdd,
  onRelease,
}: {
  phoneNumbers: PhoneNumberView[];
  onAdd: () => void;
  onRelease: (phoneNumber: string) => void;
}) => (
  <div style={phoneNumbersContainerStyle}>
    <div style={phoneNumbersHeaderStyle}>
      <h2 style={{ margin: 0 }}>Phone numbers</h2>
      <Button
        className="primary"
        style={{ fontSize: 12, padding: "4px 12px" }}
        onClick={onAdd}
      >
        + Add
      </Button>
    </div>
    {phoneNumbers.length === 0
      ? <div>No phone numbers yet.</div>
      : (
        <ul style={phoneNumbersListStyle}>
          {phoneNumbers.map((n) => (
            <li key={n.id} style={phoneNumberRowStyle}>
              <div style={phoneNumberRowHeaderStyle}>
                <span>
                  <strong>+{n.number}</strong>
                  <span style={{ fontSize: 12, opacity: 0.7, marginLeft: 8 }}>
                    (Provider: {n.provider || "unknown"}
                    {n.price ? `, $${n.price}/mo` : ""})
                  </span>
                </span>
                <Button
                  style={{ fontSize: 12, padding: "4px 12px" }}
                  onClick={() => onRelease(n.number)}
                >
                  Release
                </Button>
              </div>
              <SmsInbox messages={sortByReceivedAtDesc(n.smsMessages || [])} />
            </li>
          ))}
        </ul>
      )}
  </div>
);
